import React from "react";
import { Icon } from "antd";
import { useTranslation } from "react-i18next";

const AudienceProviderNote = ({ display }) => {
  const { t } = useTranslation();
  const provider = display.audience_provider;
  const name = provider && provider.stylized_name ? provider.stylized_name : t("display owner");

  return (
    <div className="audienceNote">
      <Icon type="bar-chart" className="audienceNote__icon" />
      <span>
        {t("Audience data for this screen provided by")} {name}
      </span>
    </div>
  );
};

export default AudienceProviderNote;
